import React from "react";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import styles from "../SettlementPortalLinkPopup.module.css";

function AlternativeTextComponent({
  onTextChange,
  FormHelperTextProps,
  text,
  error,
}) {
  return (
    <div className={styles.alternative_input_container}>
      <TextfieldInput
        label="Text"
        aria-label="Alternative Text Input"
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        error={error}
        helperText={error}
        FormHelperTextProps={FormHelperTextProps}
        required
      />
    </div>
  );
}

export default AlternativeTextComponent;
